import React from 'react';
import InputMask from "react-input-mask";

export default ({type, placeholder, icon, value, onChange, mask}) => {

    
        return (
                <div className="input-group mb-3" style={{width:130}}>
                     <input
                              type="text"
                              value={value}
                              onChange={onChange}
                              maxLength={6}
                              className="border p-2 rounded"
                              placeholder={placeholder}
                              size={6}
                            />
                     {/* <InputMask mask={mask} type={type} className="form-control"  placeholder={placeholder} value={value} onChange={onChange} /> */}
                        <div className="input-group-append">
                            <div className="input-group-text">
                                {/* <span className={icon} /> */}
                                <string>{icon}</string>
                            </div>
                        </div>
                </div>

 
        );
    }

